import React from 'react';

import type { MarketGroupType } from '@swf/sports/types/marketGroups';

import BetBuilderTab from '../BetBuilderTab/BetBuilderTab';
import StarSubTab from '../StarSubTab/StarSubTab';

interface Props {
  type: MarketGroupType;
  name: string;
}

const TabContent: React.FC<Props> = ({ type, name }) => {
  switch (type) {
    case 'BET_BUILDER':
      return <BetBuilderTab name={name} />;
    case 'STAR_SUB':
      return <StarSubTab name={name} />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{name}</>;
  }
};

export default TabContent;
